import React, { useEffect } from 'react';
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Chip,
  LinearProgress,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import DriverCoachingPlaylistTiles from './CoachingPlaylistTiles';
import CoachingPlaylistCard from './CoachingPlaylistCard';
import AlertsGrid from '../../../Vehicle-Alerts/components/AlertDataGrid';
import VideoPlayer from './ShareCoachingVideoPlayer';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import MP4VideoPlayer from '../../../../Trips/componenets/Mp4VideoPlayer';

const CoachingDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const alertState = location.state
  const {
    startDate,
    endDate,
    selectedDuration,
    // ... all other properties from row.original
  } = location.state;
  const theme = useTheme();
  // const isMobile = useMediaQuery(theme?.breakpoints.down('sm'));

  // const dos = [
  //   'Maintain a 3-second following distance.',
  //   'Use indicators before lane changes.',
  //   'Keep both hands on the wheel at all times.',
  // ];

  // const donts = [
  //   'Do not use your phone while driving.',
  //   'Do not exceed speed limits.',
  //   'Do not ignore vehicle maintenance alerts.',
  // ];

  const {
    data: driverCoachingDoDontData,
    error: driverCoachingDoDontError,
    loading: driverCoachingDoDontLoading,
    fetchData: fetchDriverCoachingDoDontData,
  } = useAxios<any>(API_ENDPOINTS.coaching.DRIVER_DO_DONT, "POST"
  );
  console.log(alertState, 'alertState');
  useEffect(() => {
    fetchDriverCoachingDoDontData({
      driverId: alertState?.driverId,
      coachingSessionId: alertState?.coachingSessionId,
      alertName: alertState?.alertName
    });
  }, [alertState])

  const dos = Array.isArray(driverCoachingDoDontData?.data) ? driverCoachingDoDontData?.data[0]?.doGuidelines : [];
  const donts = Array.isArray(driverCoachingDoDontData?.data) ? driverCoachingDoDontData?.data[0]?.dontGuidelines : [];
  const CoachingVideoUrls = Array.isArray(driverCoachingDoDontData?.data) ? driverCoachingDoDontData?.data[0]?.videoUrls : [];

  const extractVideoNameFromUrl = (url: string): string | null => {
    const match = url.match(/\/([^/]+)\/[^/]+\.mp4/);
    return match ? match[1] : null;
  };

  return (
    <Box>
      <Box
        className="flex items-center gap-2 cursor-pointer text-blue-600 hover:text-blue-800 mb-2"
        onClick={() => navigate(-1)}
      >
        <ArrowBackIcon />
        <Typography variant="body1" fontWeight={600}>
          Back
        </Typography>
      </Box>
      <Box className="flex flex-col w-full sm:w-auto mb-2" >
        <Box className="flex items-center gap-2 justify-center sm:justify-start">
          <Typography variant="h5" fontWeight={700}>
            {alertState?.alertName}
          </Typography>
          <Typography className="bg-gray-200 text-gray-800 px-3 py-1 rounded-md text-sm font-semibold">
            {alertState?.coachingStatus}
          </Typography>
        </Box>
        <Typography variant="body2" className="text-gray-500 text-center sm:text-left">
          Driver Name: {alertState?.driverName}
        </Typography>
      </Box>
      <Grid mt={2} mb={1}>
        <DriverCoachingPlaylistTiles alertState={alertState} />
      </Grid>
      <Grid mt={2} mb={1}>
        <Typography variant="h6">Event Videos</Typography>
        <CoachingPlaylistCard alertState={alertState} />
      </Grid>
      <Grid mt={2} mb={1}>
        <Typography variant="h6">Coaching Videos</Typography>
        <Box sx={{
          display: 'flex',
          overflowX: 'auto',
          gap: 2,
          p: 2,
          bgcolor: 'background.paper'
        }}>
          {CoachingVideoUrls && CoachingVideoUrls.map((videoUrl: string, index: number) => {
            const videoName = extractVideoNameFromUrl(videoUrl);

            return (
              <Box key={index} sx={{ minWidth: 300, border: '1px solid #f0eff8', borderRadius: 2, padding: 1 }}>
                <MP4VideoPlayer
                  streamUrl={videoUrl}
                  availableHeight={200}
                  availableWidth={350}
                  isRounded={true}
                />
                {videoName && (
                  <Typography variant="h6" mt={1} align="left">
                    {videoName}
                  </Typography>
                )}
              </Box>
            );
          })}
        </Box>
      </Grid>
      {(dos?.length > 0 || donts?.length > 0) &&
        <Box mt={4}>
          <Typography variant="h6">Best Practices for Safer Driving</Typography>
          <Box className='gap-4 flex justify-between items-center'>
            <Box sx={{
              backgroundColor: 'white',
              borderRadius: 2,
              border: '1px solid #f0eff8',
              flex: 1 / 2,
              padding: 2
            }}>
              <Typography variant="subtitle2" fontWeight="bold">
                Do’s:
              </Typography>
              <ul className='listing-style' style={{ paddingLeft: 20 }}>
                {dos && dos.map((item: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined, i: React.Key | null | undefined) => (
                  <li key={i}>
                    <Typography variant="body2" fontWeight={400}>{item}</Typography>
                  </li>
                ))}
              </ul>
            </Box>
            <Box sx={{
              backgroundColor: 'white',
              borderRadius: 2,
              border: '1px solid #f0eff8',
              flex: 1 / 2,
              padding: 2
            }}>
              <Typography variant="subtitle2" fontWeight="bold">
                Don’ts:
              </Typography>
              <ul className='listing-style' style={{ paddingLeft: 20 }}>
                {donts && donts.map((item: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined, i: React.Key | null | undefined) => (
                  <li key={i}>
                    <Typography variant="body2" fontWeight={400}>{item}</Typography>
                  </li>
                ))}
              </ul>
            </Box>
          </Box>
        </Box>
      }
    </Box>
  );
};

export default CoachingDetails;
